import * as serviceContext from "./serviceContext";

var options = {};
var headers = new Headers();

headers.append("Content-Type", "application/json");
options.headers = headers;

export async function getAllUsers() {
  try {
    const response = await serviceContext.get(`/GetAllUsers`, options);
    const res = await response.json();
    return res;
  } catch (error) {
    return error;
  }
}
export async function getCallLog(id) {
  try {
    const response = await serviceContext.get(`/GetUserCallLogs?userId=${id}`, options);
    const res = await response.json();
    return res;
  } catch (error) {
    return error;
  }
}

export async function sendCallLog(data) {
  try {
    const response = await serviceContext.post(`/CallLogs`, data, options);
    const res = await response.json();
    return res;
  } catch (error) {
    return error;
  }
}
export async function userList(id) {
  try {
    const response = await serviceContext.post(`/MobileUserList`, id, options);
    const res = await response.json();
    return res;
  } catch (error) {
    return error;
  }
}

export async function getActiveChats(id) {
  try {
    const response = await serviceContext.post(`/MobileUserChatList`, id, options);
    const res = await response.json();
    return res;
  } catch (error) {
    return error;
  }
}

export async function getActiveGroups(userId) {
  try {
    const response = await serviceContext.get(`/GetGroups?userId=${userId.toString()}`, options);
    const res = await response.json();
    return res;
  } catch (error) {
    return error;
  }
}

export const getMessageList = async (data) => {
  try {
    const response = await serviceContext.post(
      `/GetMessage`,
      data,
      options
    );
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
};

export const sendMessage = async (data) => {
  try {
    const response = await serviceContext.post(`/SendMessage`, data, options);
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteMessage = async (data) => {
  try {
    const response = await serviceContext.remove(`/DeleteMessage`, data, options);
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
}

export const deletcallLog = async (id) =>{
  try {
    const response = await serviceContext.remove(`/DeleteCallLogs?callId=${id}`, null , options);
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
}

export const clearHistoryChat = async (data) => {
  try {
    const response = await serviceContext.post(
      `/ClearHistoryClient`,
      data,
      options
    );
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
};

export const resetUnreadChatCount = async (data) => {
  try {
    const response = await serviceContext.post(
      `/resetChatCount`,
      data,
      options
    );
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
};

export const uploadFile = async (data) => {
  try {
    const response = await serviceContext.post(
      `/UploadFile`,
      {
        fileAsBase64: data.requestParam.fileAsBase64,
        filename: data.filename,
        message: data.message
      },
      options
    );
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
};

export const getGroup = async (groupId) => {
  try {
    const response = await serviceContext.get(`/GetSingalGroup?Id=${groupId}`, options);
    const res = await response.json();
    return res;
  } catch (error) {
    return error;
  }
}

export const addGroup = async (data) => {
  try {
    const response = await serviceContext.post(`/AddGroup`, data, options);
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
};

export const updateGroup = async (data) => {
  try {
    const response = await serviceContext.put(`/UpdateGroup`, data, options);
    const res = await response.json();
    return res;
  } catch (error) {
    return error;
  }
}

export const deleteGroup = async (groupId) => {
  try {
    const response = await serviceContext.remove(`/DeleteGroup?id=${groupId}`,null, options);
    return response;
  } catch (error) {
    return error;
  }
};

export const leaveGroup = async (data) => {
  try {
    const response = await serviceContext.post(`/LeaveGroup`, data, options);
    const res = await response;
    return res;
  } catch (error) {
    return error;
  }
}

export const PreviousMessages = async(roomId,massageId) => {
  try{
    const response = await serviceContext.get(`/LoadPreviousMessages?roomid=${roomId}&MessageId=${massageId}`, options)
    const res = await response.json();
    return res;
  }catch (error) {
    return error;
  }
}
